// Base style names (English and German alternatives)
const BULLET_STYLE_NAMES = ["List Bullet", "Aufzählungszeichen1"];
const NUMBER_STYLE_NAMES = ["List Number", "Listennummer1"];

// Style names for list creation - includes "List Paragraph" as fallback
export const LIST_BULLET_STYLES = [...BULLET_STYLE_NAMES, "List Paragraph"];
export const LIST_NUMBER_STYLES = [...NUMBER_STYLE_NAMES, "List Paragraph"];
